import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { invalidateOrganizationGroups } from './useGetOrganizationGroups';

type AssignParams = {
  organizationId: string;
  groupId: string | null;
  previousGroupId?: string | null;
};

export const useAssignOrganizationToGroup = (
  options?: UseMutationOptions<AssignParams, AxiosError, AssignParams>,
): UseMutationResult<AssignParams, AxiosError, AssignParams> => {
  const queryClient = useQueryClient();
  return useMutation<AssignParams, AxiosError, AssignParams>({
    mutationFn: async ({ organizationId, groupId, previousGroupId }) => {
      if (!organizationId) throw new Error('Brak organizationId');
      await axiosInstance.put('/v3-assignOrganizationToGroup', { organizationId, groupId });
      return { organizationId, groupId, previousGroupId };
    },
    ...options,
    onSuccess: (...args) => {
      invalidateOrganizationGroups(queryClient);
      options?.onSuccess?.(...args);
    },
  });
};

type MembersParams = { groupId: string; organizationIds: string[] };

export const useSetOrganizationGroupMembers = (
  options?: UseMutationOptions<MembersParams, AxiosError, MembersParams>,
): UseMutationResult<MembersParams, AxiosError, MembersParams> => {
  const queryClient = useQueryClient();
  return useMutation<MembersParams, AxiosError, MembersParams>({
    mutationFn: async ({ groupId, organizationIds }) => {
      await axiosInstance.put('/v3-setOrganizationGroupMembers', { groupId, organizationIds });
      return { groupId, organizationIds };
    },
    ...options,
    onSuccess: (...args) => {
      invalidateOrganizationGroups(queryClient);
      options?.onSuccess?.(...args);
    },
  });
};
